import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccess } from './hooks/useAccess';
import { SecurityOutlined as SecurityIcon } from '@mui/icons-material';

const AccessManagement: React.FC = () => {
  const { users, loading, page, setPage, totalPages } = useAccess();
  const navigate = useNavigate();

  return (
    <div className="w-full bg-white pb-10">
      <div className="w-full px-4 py-6 sm:px-6 lg:px-8">

        <div className="mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <h1 className="text-2xl font-semibold text-gray-800 flex items-center gap-3">
            <SecurityIcon fontSize="large" className="text-blue-600" />
            Управление доступом
          </h1>
        </div>

        <div className="bg-white shadow-md border border-gray-100 rounded-lg overflow-hidden">

          <div className="px-6 py-4 border-b flex flex-col sm:flex-row justify-between sm:items-center gap-2">
            <h3 className="text-lg font-medium text-gray-900">Список пользователей</h3>
          </div>

          <div className="min-h-[200px] overflow-x-auto">
            {loading ? (
              <div className="flex justify-center items-center w-full py-20">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
              </div>
            ) : (
              <table className="w-full text-left text-sm text-gray-600">
                <thead className="bg-gray-50 text-gray-700 uppercase font-medium text-xs">
                  <tr>
                    <th className="px-6 py-4 border-b">ID</th>
                    <th className="px-6 py-4 border-b">Пользователь</th>
                    <th className="px-6 py-4 border-b">Email</th>
                    <th className="px-6 py-4 border-b">Статус</th>
                    <th className="px-6 py-4 border-b text-right">Действия</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {users.length === 0 ? (
                    <tr>
                      <td colSpan={5} className="px-6 py-8 text-center text-gray-500">
                        Пользователи не найдены
                      </td>
                    </tr>
                  ) : (
                    users.map((user) => (
                      <tr key={user.id} className="hover:bg-gray-50/50 transition-colors">
                        <td className="px-6 py-4 font-medium text-gray-900">#{user.id}</td>
                        <td className="px-6 py-4">{user.full_name || '—'}</td>
                        <td className="px-6 py-4">{user.email}</td>
                        <td className="px-6 py-4">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${user.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                            {user.is_active ? 'Активен' : 'Заблокирован'}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-right">
                          <button
                            onClick={() => navigate(`/access/${user.id}`, { state: { user } })}
                            className="inline-flex items-center gap-1 px-3 py-1.5 text-sm text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md transition-colors font-medium"
                          >
                            Настроить доступ
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
          </div>

          {!loading && totalPages > 1 && (
            <div className="border-t border-gray-200 px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="text-sm text-gray-700">
                Страница <span className="font-medium">{page}</span> из <span className="font-medium">{totalPages}</span>
              </div>
              <div className="flex gap-2">
                <button
                  disabled={page === 1}
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                  className="px-4 py-2 border border-gray-300 bg-white rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 transition-colors"
                >
                  Назад
                </button>
                <button
                  disabled={page === totalPages}
                  onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                  className="px-4 py-2 border border-gray-300 bg-white rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 transition-colors"
                >
                  Вперед
                </button>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default AccessManagement;